import { FC } from 'react';
import { Option } from 'types/general.types';
import {
  Box,
  Flex,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
} from '@chakra-ui/react';
import { SongStatusType } from 'types/song';
import { getSongStatusInputComponentSx } from './styles';

interface SongStatusInputProps {
  value: string;
  options: Option[];
  onChange: (value: string | number) => void;
}

export const SongStatusInput: FC<SongStatusInputProps> = ({
  options,
  value,
  onChange,
}) => {
  const selectedOption = options.find((option) => option.value === value);
  const componentSx = getSongStatusInputComponentSx(value as SongStatusType);
  return (
    <Menu>
      <MenuButton
        sx={componentSx.status}
        aria-haspopup="true"
        data-testid="song-status"
      >
        <Flex alignItems="center">
          <Box sx={componentSx.coloredDot} />
          <Text sx={componentSx.statusText}>{selectedOption?.title}</Text>
        </Flex>
      </MenuButton>

      {/* TODO fix this */}
      <MenuList>
        {options.map((option) => (
          <MenuItem
            onClick={() => {
              onChange(option.value);
            }}
            key={option.value}
            value={option.value}
            data-testid="song-status-option"
          >
            {option.title}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
};
